import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { handleError } from "../../../helpers/ErrorHelper";
import { debounce } from "../../../helpers/Debounce";

function _success(success) {
  return { type: "GET_SITES_SUCCESS", success };
}

function _error(error) {
  return { type: "GET_SITES_ERROR", error };
}

function _processing(processing) {
  return { type: "GET_SITES_PROCESSING", processing };
}

function getSites(org_id, shouldDebounce = false) {
  return (dispatch, getState) => {
    dispatch(_processing(true));
    dispatch(_error(null));
    let { siteList } = getState();
    let { params } = siteList?.data;

    const request = () =>
      axios({
        url: apiBaseUrl(`admin/organizations/${org_id}/sites`),
        method: "get",
        dataType: "json",
        params,
        headers: {
          Authorization: "Bearer " + localStorage.getItem(`Bearer`),
        },
      })
        .then(function (res) {
          dispatch(_processing(false));
          dispatch(_success(res));
          // store.dispatch( getOrganizationStatus( org_id ) )
        })
        .catch(function (error) {
          handleError(error);
          dispatch(_error(error));
          dispatch(_processing(false));
        });

    debounce.makeRequest(request, shouldDebounce);
    // return {
    //   type: 'GET_SITES_SUCCESS',
    //   payload: request
    // }
  };
}

export default getSites;
